module.exports = __webpack_public_path__ + "img/图片6.53e59754.png";